import api from '@/security/api'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const status = () => {
    return api.get('/dashboard/chart-status')
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os status')
        })
}

const serviceUsage = (days) => {
    days = days || 10
    return api.get(`/dashboard/serviceusage?period=${days}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os dados de uso.')
        })
}

export default {
    status,
    serviceUsage
}
